export default __webpack_public_path__ + "assets/images/111576814976c507556afc2e24dfe2c0.png";